export default __webpack_public_path__ + "static/media/910.a2eef0e6.gif";